import { CostValidation } from '../types/TrendsTypes';
import { NON_PROD_SUBSCRIPTION_NAME, PROD_SUBSCRIPTION_NAME } from '../constant';

export const getNonProdData = (data: CostValidation[]) => {
  return data.filter((costValidationObject) => costValidationObject.subscriptionName === NON_PROD_SUBSCRIPTION_NAME);
};

export const getProdData = (data: CostValidation[]) => {
  return data.filter((costValidationObject) => costValidationObject.subscriptionName === PROD_SUBSCRIPTION_NAME);
};

export const getProdAndNonProdData = (data: CostValidation[]) => {
  return [
    ...data
      .reduce((p, c) => {
        const key = c.resourceName + c.date;
        let costValidate;
        if (p.has(key)) {
          costValidate = p.get(key);
          costValidate.cost += c.cost;
        } else {
          costValidate = { ...c };
        }
        p.set(key, costValidate);
        return p;
      }, new Map())
      .values()
  ];
};
